import axios from "axios";
import { eApplicationPermission } from "../enums";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export interface MeReturn {
  userId?: number;
  isAdmin?: boolean;
  applicationPermissions?: eApplicationPermission[];
}

export type IMeReturn = IAxiosReturn<MeReturn>;

/**
 * Gets information about the current user.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @returns A promise resolving to `IMeReturn` with current user's ID, admin flag and permissions.
 */
export const getMe = async (backEndUrl: string): Promise<IMeReturn> => {
  const url = `${backEndUrl}Users/Me`;
  // Get data
  try {
    const response: {
      data: {
        userId: number;
        isAdmin: boolean;
        applicationPermissions: eApplicationPermission[];
      };
    } = await axios.get(url);
    // Return successful result
    return {
      success: true,
      data: {
        userId: response.data.userId,
        isAdmin: response.data.isAdmin,
        applicationPermissions: response.data.applicationPermissions,
      },
    };
  } catch (error: unknown) {
    return processAxiosError("Load me failed", error);
  }
};
